import {createModel} from '@rematch/core';
import {RootModel} from './index';

import {auth, db} from '../../Firebase/main';
import {IUser} from '../../Constants/Interfaces';


interface users {
    data: { [id: string]: IUser };
}


const init: users = {
    data: {},
};

export const Users = createModel<RootModel>()({
    state: init,
    reducers: {
        update(state, payload: Partial<users>) {
            return {...state, ...payload};
        },
        updateUsers(state, payload: typeof init.data) {
            return {...state, data: {...state.data, ...payload}};
        },
    },
    effects: (dispatch) => ({
        async getUsers(): Promise<void> {
            const usersRef = db.ref('users');

            // Get online users
            await usersRef
                .orderByChild('online')
                .equalTo(true)
                .get()
                .then((snap) => {
                    if (snap.exists()) {
                        const data = snap.val();
                        dispatch.users.updateUsers(data);
                    }
                });

            // Attach listeners
            await usersRef
                .on('child_changed', (snap) => {
                    const userId = snap.key;
                    if (userId && snap.exists()) {
                        const userData = snap.val() as IUser;
                        dispatch.users.updateUsers({[userId]: userData});
                    }
                });
        },

        async addAddress(address: string): Promise<void> {
            const myId = auth.currentUser?.uid;

            if (!myId) {
                return;
            }

            const ref = db.ref(`users/${myId}/pm_addresses`);

            ref
                .get()
                .then((snap) => {
                    if (snap.exists()) {
                        ref
                            .update([...snap.val(), address])
                            .catch(console.log);
                    }
                    else {
                        console.log('no addresses');
                        ref.set([address]).catch(console.log);
                    }
                })
                .catch(console.log);
        },

        async updateAddresses(addresses: string[]): Promise<void> {
            const myId = auth.currentUser?.uid;

            if (!myId) {
                return;
            }

            const ref = db.ref(`users/${myId}/pm_addresses`);

            ref.set(addresses).catch(console.log);
        },

        async toggleBuddy(payload: {
            buddyId: string;
            myBuddies: string[];
        }): Promise<void> {
            const myId = auth.currentUser?.uid;
            if (!myId) return;
            const isBuddy = payload.myBuddies.includes(payload.buddyId);
            await db
                .ref('users/' + myId + '/buddies')
                .set(
                    isBuddy
                        ? payload.myBuddies.filter((buddyId) => buddyId !== payload.buddyId)
                        : [...payload.myBuddies, payload.buddyId],
                );
        },

        async toggleBlock(payload: {
            blockedUser: string;
            myId: string;
            blacklist: string[];
        }): Promise<void> {
            const isBlocked = payload.blacklist.includes(payload.blockedUser);
            await db
                .ref('users/' + payload.myId + '/blacklist')
                .set(
                    isBlocked
                        ? payload.blacklist.filter((id) => id !== payload.blockedUser)
                        : [...payload.blacklist, payload.blockedUser],
                );
        },
    }),
});
